import { useEffect } from "react"
import { batch, useSignal } from "@preact/signals-react"
import { FORMAT_DATE_BACK, formatDate, postSubmit } from "@ui-seeker/utils"

import { WEBBACK_V2_API } from "@constants"
import { isSystemBusy } from "@signals"
import { retailersTrackedData, retailersTrackedDate, retailersTrackedIsEmpty } from "../@signals"

// The screen lives in Info Center but its endpoint is in the pricing nested — v1's layout, kept by
// v2 so the url only changes prefix. No role branch: this list has no reference price, so v1 has a
// single nested for it and v2 a single route.
//
// ⚠️ The two extraction columns report the **whole** history of each site and ignore the selected
// date. Until HeatWave's `PRICING_RAW` holds more than 131 days, `firstExtraction` answers March
// 2026 where v1 answers January 2025 — §2 of dipi-webback-v2/docs/descuadres-dato-heatwave.md. Every
// other column matches v1 exactly.
const V2_RETAILERS_TRACKED = `${WEBBACK_V2_API}/pricing/retailers-tracked`

export default function useRetailersTracked() {
	const isLoading = useSignal(true)

	useEffect(() => {
		isLoading.value = true
		isSystemBusy.value = false
		batch(() => {
			retailersTrackedData.value = []
			retailersTrackedIsEmpty.value = false
		})

		postSubmit(`${V2_RETAILERS_TRACKED}/context`, { date: formatDate(retailersTrackedDate.value, { format: FORMAT_DATE_BACK }) })
			.then(res => batch(() => {
				if (!res.length) retailersTrackedIsEmpty.value = true
				else retailersTrackedData.value = res
			}))
			.catch(() => isSystemBusy.value = true)
			.finally(() => isLoading.value = false)
	}, [retailersTrackedDate.value])

	return { isLoading: isLoading.value }
}
